<template>
    <div class="product-list-page" onselectstart='return false' onselect='return false' oncontextmenu='return false'>
        <PublicHead1></PublicHead1>
        <div class="Product">
            <div class="location">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item
                        v-for="item in breadcrumb"
                        :to="item.redirect || item.path"
                        :key="item.path"
                        >{{ item.name }}</el-breadcrumb-item
                    >
                </el-breadcrumb>
            </div>
            <!-- 产品列表 -->
            <ul class="clear" id="product">
                <li v-for="product in products" :key="product.id">
                    <div class="Img" @click="$router.push(`/tools/${product.id}`)">
                        <img :src="product.image">
                    </div>
                    <p class="producttitle">
                        <i class="icon"></i>
                        {{ product.name }}
                    </p>
                </li>
            </ul>
        </div>
        <PublicFoot></PublicFoot>
    </div>
</template>

<script>
import PublicHead1 from "@/pages/front/components/head1.vue";
import PublicFoot from "@/pages/front/components/foot.vue";
import config from "../../../api/config";
import { getList, delProduct } from "@/api/gm/api-product";
export default {
    data() {
        return {
            name: "产品",
            breadcrumb: [],
            staticURL: config.staticURL, //图片域名
            hoverIndex: -1, //判断选中状态
            products: null
        };
    },
    components: {
        PublicHead1,
        PublicFoot
    },
    created() {
        this.getBreadcrumb();
        getList().then(res => {
            if (res.code === 0) {
                this.products = res.data;
                this.products.forEach(i => {
                    i.image = this.staticURL + i.image;
                });
            } else {
                console.log(res.msg);
            }
        });
    },
    mounted() {
        // this.getBreadcrumb();
    },
    methods: {
        // 锁定定位
        getBreadcrumb() {
            this.breadcrumb = this.$route.matched.filter(p => p.path !== "");
        },
        // 点击产品跳转
        /*editProduct(id) {
            this.$router.push({ path: "/tool-list", query: { id } });
        }*/
    }
};
</script>
<style lang="less" scoped>
body {
    background: url(../../../assets/front/icon-loginbg.png) center bottom
        no-repeat;
}
html,
body {
    height: 100%;
    min-height: 100%;
   // overflow : unset !important;

}
/deep/.copyright{
  position: relative;
}
.product-list-page {
  background: url(../../../assets/front/icon-loginbg.png) center bottom
        no-repeat;
    position: relative;
    height: 100vh;
    // padding: 0px 0px 1vh 0px;
    overflow-y: auto;
    overflow-x: hidden;
}
/deep/.product-list-page {
    /deep/.head-page {
        background-color: #eee;
    }
}
.location {
    margin: 20px 0px 0px 0px;
    padding: 0px 0px 0px 23px;
    line-height: 30px;
    font-size: 16px;
    color: #313131;
    background: url("../../../assets/front/icon-home.png") left center no-repeat;
    .el-breadcrumb__inner {
        font-size: 16px;
        color: #313131;
    }
    /deep/.el-breadcrumb{
      box-shadow: 0px 0px 0px 0px #fff;
      border-bottom: 0px;
    }
}
.Product {
    width: 1000px;
    margin: 0 auto;
    min-height:83vh;
    ul {
        padding: 0px;
        margin: 1.5vw 0px 20px 0px;
        clear: both;
        overflow: hidden;
        li {
            width: 485px;
            list-style: none;
            float: left;
            margin: 0px 0px 1.2vw 0px;
            cursor: pointer;
            &:nth-child(2n) {
                float: right;
            }
            &:hover {
                .producttitle {
                    color: #214d98;
                    .icon {
                        background: #214d98;
                    }
                }
            }
            .Img {
                width: 100%;
                height: 240px;
                background: #ccc;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .producttitle {
                font-size: 20px;
                color: #1b1b1b;
                text-align: center;
                margin: 0px;
                height: 40px;
                line-height: 40px;
                overflow: hidden;
                .icon {
                    background: #1b1b1b;
                    width: 5px;
                    height: 5px;
                    display: inline-block;
                    border-radius: 50%;
                    position: relative;
                    top: -4px;
                    margin: 0px 10px 0px 0px;
                }
            }
        }
    }
}
@media (max-width: 1024px) {
    body {
        background: url(../../../assets/front/icon-loginbg1.png) center bottom
            no-repeat;
    }
    .Product {
        width: 95%;
        ul {
            li {
                width: 100%;
                margin: 0px 0px 15px 0px;
                .Img {
                    height: 46vw;
                }
                .producttitle {
                    font-size: 16px;
                    height: 30px;
                    line-height: 30px;
                    .icon {
                        margin: 0px 5px 0px 0px;
                    }
                }
            }
        }
    }
    .product-list-page {
        padding: 0px 0px 70px 0px;
    }
    .location{
      margin:20px 0px;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/front/product-list/product-list.vue